<script lang="ts" setup>
import BaseDialog from '@/components/dialogs/BaseDialog.vue'

defineProps<{
  groupName: string
}>()

const emit = defineEmits<{
  (event: 'action' | 'close'): void
}>()

const { t } = useI18n()
</script>

<template>
  <base-dialog
    data-cy="delete_group_dialog"
    max-width="580"
    action-color="error"
    :title="t('business.groups.delete.title', { groupName })"
    :action-text="t('business.groups.delete.action_text')"
    :cancel-text="t('business.groups.delete.cancel_text')"
    @close="emit('close')"
    @action="emit('action')"
  >
    <div>
      <p class="text-subtitle-1 subtitle">
        {{ t('business.groups.delete.subtitle_1.part_1') }}
        <span class="subtitle__bolded">
          {{ t('business.groups.delete.subtitle_1.part_2') }}
        </span>
        {{ t('business.groups.delete.subtitle_1.part_3') }}
        <span class="subtitle__bolded">
          {{ t('business.groups.delete.subtitle_1.part_4') }}
        </span>
      </p>
      <br />
      <p class="text-subtitle-1 subtitle">
        {{ t('business.groups.delete.subtitle_2.part_1') }}
        <span class="subtitle__bolded">
          {{ t('business.groups.delete.subtitle_2.part_2') }}
        </span>
        {{ t('business.groups.delete.subtitle_2.part_3') }}
        <span class="subtitle__bolded">
          {{ t('business.groups.delete.subtitle_2.part_4') }}
        </span>
      </p>
    </div>
  </base-dialog>
</template>

<style lang="scss" scoped>
.subtitle {
  color: $c-skribbleu;
  &__bolded {
    font-weight: 800;
  }
}
</style>
